import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

const initialState = {
    id: null,
    descricao: '',
    num: '',
    quantidade: '',
    tipo: ''
}

export default function AcabamentoTemperaturaConfiguracao() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get('acabamento/temperatura-configuracao').then((response) => {
            setIsLoading(false);
            setData(response.data);
        }).catch((error) => {
            setIsLoading(false);
            setData([]);
        });
    }, []);

    const onHide = () => {
        if(isEditing) {
            setIsEditing(false);
            setForm({...initialState});
        }
        setIsVisible(false);
    }

    const handleSubmit = () => {
        if(isEditing && form.id !== null) {
            setIsLoading(true);
            api.put(`acabamento/temperatura-configuracao/${form.id}/update`, form).then(response => {
                fetchData();
                onHide();
                setIsLoading(false);
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post('acabamento/temperatura-configuracao', form).then(response => {
                fetchData();
                onHide();
                setIsLoading(false);
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]); 

    if(isLoading)
        return <Loading />

    return (
        <div
            className="p-m-1"
            title="Temperatura - Configuração"
        >
            <Menu />
            <Toast ref={toast} />

            <Dialog
                footer={() => (
                    <div>
                        <Button 
                            className="p-button-secondary"
                            label="Cancelar"
                            onClick={onHide}
                        />

                        <Button 
                            className="p-button-success"
                            label="Salvar"
                            onClick={handleSubmit}
                        />
                    </div>
                )}
                header={isEditing ? "Editar": "Cadastrar"}
                onHide={onHide}
                style={{ minWidth: '30vw' }}
                visible={isVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="descricao">Descrição: </label>
                        <InputText
                            onChange={e => setForm({...form, descricao: e.target.value })}
                            value={form.descricao}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="tipo">Tipo: </label>
                        <Dropdown 
                            options={[
                                { label: 'Caixa', value: 'C' },
                                { label: 'Secadeira', value: 'S' }
                            ]}
                            onChange={e => setForm({...form, tipo: e.value })}
                            placeholder="-- Selecione o TIPO da configuração --"
                            value={form.tipo}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="n">Nº</label>
                        <InputText 
                            onChange={e => {
                                if(parseInt(e.target.value) || e.target.value === '') {
                                    setForm({...form, num: e.target.value === '' ? '' : parseInt(e.target.value) })
                                }
                            }}
                            placeholder="1"
                            value={form.num}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="quantidade">Quantidade: </label>
                        <InputText
                            onChange={e => setForm({...form, quantidade: e.target.value })}
                            placeholder="Exemplo: 2"
                            value={form.quantidade}
                        />
                    </div>
                </div>
            </Dialog>

            <Card
                className="p-m-1"
                title="Temperatura - Configuração"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-m-1"
                        icon="pi pi-plus"
                        onClick={() => { setIsVisible(true); }}
                        title="Clique para cadastrar uma configuração"
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="Tipo" filterField="tipo" sortable sortField="tipo" body={(rowData) => {
                        if(rowData.tipo === 'S') {
                            return <p>Secadeira</p>
                        } else {
                            return <p>Caixa</p>
                        }
                    }} />
                    <Column header="Descrição" field="descricao" sortable />
                    <Column header="Nº" field="num" sortable />
                    <Column header="Quantidade" field="quantidade" sortable />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-info"
                                icon="pi pi-pencil"
                                onClick={() => {
                                    setForm({...rowData});
                                    setIsEditing(true);
                                    setIsVisible(true);
                                }}
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}